










































import { addDays } from 'date-fns';
import Component from 'vue-class-component';
import Vue from 'vue';
import { Emit, Watch } from 'vue-property-decorator';
import {
    createPeriodListItems,
    parsePeriodListItem,
    subPeriod,
    toStrPeriod
} from '@/utils';
import {
    IDictionary,
    IFormControl,
    IListItem,
    GroupBy,
    IGetPeriodsStatsModel,
    DateRangeMapper,
    IPeriod,
    IPeriodShort
} from '../../../entities';
import { FormFilterComponent } from '../../../components/base/form-filter/form-filter.component';

@Component({})
export default class OfficeProgressCriteria extends FormFilterComponent {
    public hints: IListItem[] = [
        { heading: 'Choose payout period', value: null },
        ...createPeriodListItems(50, 27)
    ];

    public formState: IDictionary<IFormControl> = {
        hint: {
            key: 'hint',
            label: '',
            value: null
        },
        periodsLabel: {
            key: 'periodsLabel',
            label: '',
            value: null
        },
        period1: {
            key: 'period1',
            label: 'Period 1',
            value: null,
            mapper: DateRangeMapper
        },
        period2: {
            key: 'period2',
            label: 'Period 2',
            value: null,
            mapper: DateRangeMapper
        }
    };

    public async created() {
        this.doSearch();
    }

    @Emit()
    public search(body: IGetPeriodsStatsModel) {
        // empty
    }

    public hintChange() {
        if (this.formState.hint.value) {
            const period2 = parsePeriodListItem(this.formState.hint.value);
            const period1 = subPeriod(period2, 1);
            this.formState.period1.value = period1;
            this.formState.period2.value = period2;
        }
    }

    public getQueryObject(formState: IDictionary<IFormControl>) {
        const period1 = this.formState.period1.value;
        const period2 = this.formState.period2.value;
        return {
            period1: toStrPeriod(period1),
            period2: toStrPeriod(period2),
            groupBy: GroupBy.Company,
            sortField: 'name', // todo: override
            sortAsc: true // todo: override
        };
    }

    public defaultFormValues(): IDictionary<any> {
        const period2 = parsePeriodListItem(this.hints[1].value);
        return {
            hint: this.hints[1].value,
            period1: subPeriod(period2, 1),
            period2
        };
    }

    public periodsChange(val: IPeriodShort[]) {
        this.formState.period1.value = val[0];
        this.formState.period2.value = val[1];
    }

    @Watch('$route') private onRouteChanged(val: string, oldVal: string) {
        this.doSearch();
    }

    @Watch('formState.period1.value')
    @Watch('formState.period2.value')
    private onChangePeriods() {
        let findHint: string = this.hints[0].value;
        this.hints.map((hint) => {
            if (hint.value) {
                const period2 = parsePeriodListItem(hint.value);
                const period1 = subPeriod(period2, 1);
                if (
                    period1.start.getTime() ===
                        this.formState.period1.value.start.getTime() &&
                    period1.end.getTime() ===
                        this.formState.period1.value.end.getTime() &&
                    period2.start.getTime() ===
                        this.formState.period2.value.start.getTime() &&
                    period2.end.getTime() ===
                        this.formState.period2.value.end.getTime()
                ) {
                    findHint = hint.value;
                }
            }
        });
        this.formState.hint.value = findHint;
    }
}
